import React from 'react';
import './sectiontitle.css'

const Sectiontitle = (props) => {
  return ( 
    <div className='section_title_heading'>
      <div className='section_title_green'>{props.titlegreen}</div>
      <div className='section_title_orange'>{props.titleorange}</div>
    </div>
   );
}
 
export default Sectiontitle;
